// @ts-nocheck
// Lemon Squeezy checkout configuration.
// Store/variant IDs live in source (not env vars) because the public store
// page is already public information — no secret to protect here.

export const LEMON_STORE = "eiforall.lemonsqueezy.com";
export const LEMON_STORE_ID = 366893;
// Variant ID for the EI book product. Refreshed 2026-05-24: the prior
// UUID (3e04419c-3bfe-4e1d-a9c3-28b6f1854366) belonged to a test-mode
// product. The current value is the live-mode variant for product 1084177.
export const LEMON_VARIANT_ID = "1698907";

import { supabase } from "./supabase";

function postPurchaseUrl(): string {
  if (typeof window === "undefined") return "https://eiforall.com/payment-success";
  return `${window.location.origin}/payment-success`;
}

// Direct-buy URL (legacy fallback). The `checkout[locale]=en` param pins
// only the *page* locale — the *cart* locale is decided server-side from
// Accept-Language. For Hebrew-only browsers that produces a Bulgarian
// overlay (LS falls back to bg when no supported language is in Accept-
// Language). That is why we prefer the API path below; this URL is only
// the fallback when the edge function is unreachable.
function buildDirectCheckoutUrl(email?: string | null): string | null {
  if (!LEMON_VARIANT_ID) return null;
  const params = new URLSearchParams({
    embed: "1",
    desc: "0",
    logo: "0",
    media: "0",
    "checkout[locale]": "en",
    "checkout[success_url]": postPurchaseUrl(),
  });
  if (email) params.set("checkout[email]", email);
  return `https://${LEMON_STORE}/buy/${LEMON_VARIANT_ID}?${params.toString()}`;
}

// Async preferred path: ask the `create-checkout` Supabase Edge Function
// to mint a one-time checkout via the LS API with `locale: "en"` baked
// into the cart object, returning a URL whose locale cannot be overridden
// by the browser's Accept-Language. Falls back to the direct buy URL if
// the function is unreachable, so the buy button is never dead.
export async function buildCheckoutUrl(email?: string | null): Promise<string | null> {
  if (!LEMON_VARIANT_ID) return null;
  try {
    const { data, error } = await supabase.functions.invoke("create-checkout", {
      body: {
        email: email ?? "",
        redirect_url: postPurchaseUrl(),
      },
    });
    if (error) throw error;
    if (data && typeof data === "object" && typeof (data as { url?: unknown }).url === "string") {
      return (data as { url: string }).url;
    }
    throw new Error("create-checkout returned no url");
  } catch (err) {
    console.warn("create-checkout failed, falling back to direct URL", err);
    return buildDirectCheckoutUrl(email);
  }
}

// Opens the Lemon.js overlay if the script has loaded; otherwise falls
// back to a full-page navigation. The overlay is preferred because the
// user stays on our domain and we capture the success redirect cleanly.
export function openLemonCheckout(url: string): void {
  const w = window as unknown as {
    LemonSqueezy?: { Url: { Open: (u: string) => void } };
  };
  if (w.LemonSqueezy?.Url?.Open) {
    w.LemonSqueezy.Url.Open(url);
  } else {
    window.location.href = url;
  }
}
